import {
  Autocomplete,
  TextField,
  IconButton,
  FormControlLabel,
  Grid,
  Box,
  InputBase,
  Switch,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { AuditHeaderToolbarProps } from '../Model/AuditProps';
import { auditService } from '../AuditService';
import { PortalUser } from '../Model/AuditModel';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import { Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';

export default function AuditHeaderToolbar({
  excludeAutomationEnties,
  setExcludeAutomationEnties,
  Entity,
  selectedUsers,
  setEntity,
  setSelectedUsers,
}: Readonly<AuditHeaderToolbarProps>) {
  const [availableUsers, setAvailableUsers] = useState<PortalUser[]>([]);
  const [searchQuery, setSearchQuery] = useState(Entity);
  const { t } = useTranslation('audit');

  useEffect(() => {
    const loadAuditPerformers = async () => {
      try {
        const response = await auditService.GetAuditPerformers();
        setAvailableUsers(response.Items);
      } catch (error) {
        showToast({
          title: t('audit.error.fetchingPerformers'),
          type: 'error',
        });
        console.error(error);
      }
    };

    loadAuditPerformers();
  }, []);

  const handleSearch = () => {
    setEntity(searchQuery);
    setSelectedUsers([...selectedUsers]);
  };

  return (
    <HeaderToolbar
      leftContent={
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: 1,
                borderColor: 'grey.400',
                borderRadius: 2,
                px: 1.5,
                py: 0.5,
                width: '100%',
                height: '40px',
              }}
            >
              <InputBase
                placeholder="Search entity"
                sx={{ flex: 1, fontSize: '0.9rem', height: '40px' }}
                inputProps={{ 'aria-label': 'Search' }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <IconButton onClick={handleSearch} color="primary">
                <SearchIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              value={selectedUsers}
              options={availableUsers}
              onChange={(event, newValue) => setSelectedUsers(newValue)}
              getOptionLabel={(option) => option.Username}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Performed by …"
                  size="small"
                />
              )}
            />
          </Grid>
        </Grid>
      }
      rightContent={
        <FormControlLabel
          control={
            <Switch
              checked={excludeAutomationEnties}
              color="primary"
              inputProps={{ 'aria-label': 'Exclude Automation Entries' }}
              onChange={(e) => setExcludeAutomationEnties(e.target.checked)}
            />
          }
          label="Exclude automation"
        />
      }
    />
  );
}
